export interface System {
  id: string;
  org_id: string;
  zone_id: string;
  name: string;
  function?: string;
  protocols?: string[];
  operating_hours?: {
    start_time: string;
    end_time: string;
    weekdays: string[];
  };
  owner?: string;
  depends_on_system_ids?: string[];
  rto?: number;
  rpo?: number;
  failover_tested?: boolean;
  processes_pii?: boolean;
  pii_types?: string[];
  dpia_required?: boolean;
  created_at: string;
  updated_at: string;
}

export type SystemInsert = Omit<System, 'id' | 'created_at' | 'updated_at'> & {
  id?: string;
};

export type SystemUpdate = Partial<
  Omit<System, 'id' | 'org_id' | 'zone_id' | 'created_at' | 'updated_at'>
>;

export const SYSTEM_FUNCTIONS = {
  IT: ['AD & Identity', 'Corporate Wi-Fi', 'Email & Collaboration', 'File Services', 'Backup & Recovery', 'Network Management'],
  OT: ['SCADA', 'Packaging Line', 'Production Line', 'Quality Control', 'Safety Systems', 'Maintenance'],
  DMZ: ['Historian Mirror', 'Remote Access', 'External Web Services'],
  Cloud: ['Data Platform', 'Analytics', 'Backup Services', 'SaaS Applications']
};
